module.exports = __webpack_public_path__ + "static/img/7.420acf5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/sp/7.png
// module id = xsTA
// module chunks = 0